import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Grid from './Grid/Grid';
import List from './List/List';
import Map from './Map/Map';
import Detail from './Detail/Detail';
import BadProperties from './BadProperties';
import { Redirect, withRouter } from 'react-router-dom';

const Routes = ({
    screen,
    history,
    properties,
    filters,
    map,
    searchMap,
    handleMapClick,
    currentPath,
    filtersOff,
    filterMapOff,
    handleClear,
    handleMapOver,
}) => (
    <Switch>
        <Route exact path="/office/" render={() =>
            <Grid isDesktop={screen.isDesktop} properties={properties} filters={filters} />
        } />
        <Route exact path="/office/list" render={() =>
            <List properties={properties} filters={filters} />
        } />
        <Route exact path="/office/map" render={() =>
            <Map
                properties={properties}
                filters={filters}
                map={map}
                searchMap={searchMap}
                handleMapClick={handleMapClick}
                handleMapOver={handleMapOver}
            />
        } />
        {/* Temporary route for fixing CMS data issues */}
        <Route exact path="/office/bad" render={() => <BadProperties />} />
        <Route path="/office/:slug" render={() =>
            <Detail
                history={history}
                properties={properties}
                filters={filters}
                filtersOff={filtersOff}
                filterMapOff={filterMapOff}
                handleClear={handleClear}
                currentPath={currentPath.substring(0, 1) === '/' ? currentPath.substring(1) : currentPath}
            />
        } />
    </Switch>
);

Routes.propTypes = {
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        isDesktop: PropTypes.bool.isRequired,
    }),
    history: PropTypes.object.isRequired,
    properties: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    map: PropTypes.shape({
        zoom: PropTypes.number.isRequired,
        center: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        }).isRequired,
        propertyId: PropTypes.string,
    }).isRequired,
    searchMap: PropTypes.func.isRequired,
    handleMapClick: PropTypes.func.isRequired,
    handleMapOver: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
    filtersOff: PropTypes.bool.isRequired,
    filterMapOff: PropTypes.bool.isRequired,
    currentPath: PropTypes.string.isRequired,
};

export default Routes;
